module.exports = __webpack_public_path__ + "img/top_goannai.8dc0d838.jpg";